<script setup>
import Divider from '@/Components/Divider.vue';
import LoginForm from '@/Pages/Firebase/Auth/LoginForm.vue';
import LoginSocial from '@/Pages/Firebase/Auth/LoginSocial.vue';
import RegisterForm from '@/Pages/Firebase/Auth/RegisterForm.vue';
import { ref } from 'vue';

import { trans, transChoice } from 'laravel-vue-i18n';

const props = defineProps({
    show_social_connexion: { type: Boolean, default: true, },
    layout: { type: Object }
});

const switched = ref(true);

defineExpose({
    switched,
});
</script>

<template>

    <div id="authentication-box" class="mt-4">

        <!-- <pre>layout.colors: {{ layout.colors }}</pre> -->

        <!-- <Divider v-if="show_social_connexion" class="mt-12" :label="trans('Ou avec votre e-mail')" /> -->
        <!-- <h3 class="mt-4 mb-6 text-center text-2xl font-bold">
            <template v-if="switched">
                {{ trans('Créer votre compte') }}
            </template>
            <template v-else>
                {{ trans('Je me connecte') }}
            </template>
        </h3> -->

        <!-- Question  -->
        <div class="mt-4 mb-8 text-center flex items-center justify-center gap-4">
            <span @click="switched = true" class=" rounded-md cursor-pointer py-2 px-3 select-none" :class="{
                [`
                font-medium 
                bg-[${layout.colors.secondary_color}] 
                text-[${layout.colors.txt_default}] 
                dark:bg-[${layout.colors.background}] 
                dark:text-white`]
                : switched, [`
                text-gray-600  
                dark:text-gray-300 
                dark:hover:text-white
                font-medium`]: !switched
            }">
                <!-- {{ trans('Je m\'inscris') }} -->
                {{ trans('Créer mon compte') }}
            </span>
            <span @click="switched = false" class="rounded-md cursor-pointer py-2 px-3 select-none font-medium" :class="{
                [`
                font-medium 
                bg-[${layout.colors.secondary_color}] 
                text-[${layout.colors.txt_default}] 
                dark:bg-[${layout.colors.background}] 
                dark:text-white 
                `]: !switched, ' text-gray-600 dark:text-gray-300 dark:hover:text-white': switched
            }">
                {{ trans('J\'ai déjà un compte') }}
            </span>
            <label class="relative inline-flex items-center cursor-pointer hidden">
                <input type="checkbox" id="switch" value="" class="sr-only peer" v-model="switched">
                <div class="w-11 h-6 bg-gray-800 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 dark:peer-focus:ring-indigo-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-indigo-600">
                </div>
            </label>

        </div>
        <h3 class="mb-8 text-center text-xl font-bold">
            <!-- <span :class="{ 'inline': switched, 'hidden': !switched }">
                {{ trans('Créer mon compte') }}
            </span> 
            <span :class="{ 'inline': !switched, 'hidden': switched }">
                {{ trans('Se connecter') }}
            </span> -->
        </h3>
        <div class="max-w-xl mx-auto">
            <Transition>
                <LoginForm v-show="!switched" />
            </Transition>
            <Transition>
                <RegisterForm v-show="switched" />
            </Transition>
        </div>
    </div>
    <div class="my-4">
        <Divider :label="trans('Connexion sociale')" />
        <LoginSocial />
    </div>
</template>
